import { Tag, TagProps, useStyles } from 'bold-ui'

export const FilterTag = (props: TagProps) => {
  const { theme } = useStyles()
  const tagStyles = {
    color: theme.pallete.status.info.main,
    background: theme.pallete.status.info.background,
    border: `1px solid ${theme.pallete.status.info.main}`,
  }
  return (
    <Tag {...props} type='info' removable style={tagStyles}>
      {props.children}
    </Tag>
  )
}
